import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoSearchResultsMobile = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 208,
	height: 191,
	viewBox: "0 0 208 191",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 125.733,
					cy: 14.5665,
					r: 3.45,
					stroke: "#ACB5B9",
					strokeWidth: .766667
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 70.5333,
					cy: 181.7,
					r: 3.45,
					stroke: "#ACB5B9",
					strokeWidth: .766667
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 167.9,
					cy: 22.2332,
					r: 3.83333,
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 203.933,
					cy: 129.566,
					r: 3.83333,
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 3.06667,
					cy: 29.1331,
					r: 2.68333,
					stroke: "#ACB5B9",
					strokeWidth: .766667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1143 1.94312C49.3613 1.27565 50.3053 1.27565 50.5523 1.94312L51.3675 4.14616C51.4452 4.35601 51.6106 4.52146 51.8205 4.59912L54.0235 5.41431C54.691 5.6613 54.691 6.60537 54.0235 6.85235L51.8205 7.66755C51.6106 7.7452 51.4452 7.91066 51.3675 8.12051L50.5523 10.3235C50.3053 10.991 49.3613 10.991 49.1143 10.3235L48.2991 8.12051C48.2214 7.91066 48.056 7.7452 47.8461 7.66755L45.6431 6.85235C44.9756 6.60537 44.9756 5.6613 45.6431 5.41431L47.8461 4.59912C48.056 4.52146 48.2214 4.35601 48.2991 4.14616L49.1143 1.94312Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.048 63.2764C184.295 62.6089 185.239 62.6089 185.486 63.2764L186.301 65.4794C186.379 65.6893 186.544 65.8547 186.754 65.9324L188.957 66.7476C189.624 66.9946 189.624 67.9386 188.957 68.1856L186.754 69.0008C186.544 69.0785 186.379 69.2439 186.301 69.4538L185.486 71.6568C185.239 72.3243 184.295 72.3243 184.048 71.6568L183.232 69.4538C183.155 69.2439 182.989 69.0785 182.779 69.0008L180.576 68.1856C179.909 67.9386 179.909 66.9946 180.576 66.7476L182.779 65.9324C182.989 65.8547 183.155 65.6893 183.232 65.4794L184.048 63.2764Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.41431 138.41C5.6613 137.742 6.60537 137.742 6.85235 138.41L7.66755 140.613C7.7452 140.823 7.91066 140.988 8.12051 141.066L10.3235 141.881C10.991 142.128 10.991 143.072 10.3235 143.319L8.12051 144.134C7.91066 144.212 7.7452 144.377 7.66755 144.587L6.85235 146.79C6.60537 147.458 5.6613 147.458 5.41431 146.79L4.59912 144.587C4.52146 144.377 4.35601 144.212 4.14616 144.134L1.94312 143.319C1.27565 143.072 1.27565 142.128 1.94312 141.881L4.14616 141.066C4.35601 140.988 4.52146 140.823 4.59912 140.613L5.41431 138.41Z",
					fill: "#ACB5B9"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dddd_6380_7332)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M108.592 40.103C111.132 40.1031 113.191 42.1623 113.192 44.7026V148.203C113.192 150.743 111.132 152.803 108.592 152.803H54.9249C52.3845 152.803 50.3253 150.743 50.3253 148.203V44.7026C50.3255 42.1623 52.3846 40.1032 54.9249 40.103H108.592Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.592 40.103C111.132 40.1031 113.191 42.1623 113.192 44.7026V148.203C113.192 150.743 111.132 152.803 108.592 152.803H54.9249C52.3845 152.803 50.3253 150.743 50.3253 148.203V44.7026C50.3255 42.1623 52.3846 40.1032 54.9249 40.103H108.592Z",
					stroke: "#5E696E",
					strokeWidth: 3.06667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.6919 139.77C55.6919 138.923 56.3784 138.236 57.2252 138.236H64.1252C64.9721 138.236 65.6586 138.923 65.6586 139.77V146.67C65.6586 147.516 64.9721 148.203 64.1252 148.203H57.2252C56.3784 148.203 55.6919 147.516 55.6919 146.67V139.77Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.4918 139.77C69.4918 138.923 70.1783 138.236 71.0252 138.236H77.9252C78.772 138.236 79.4585 138.923 79.4585 139.77V146.67C79.4585 147.516 78.772 148.203 77.9252 148.203H71.0252C70.1783 148.203 69.4918 147.516 69.4918 146.67V139.77Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M83.2919 139.77C83.2919 138.923 83.9784 138.236 84.8252 138.236H91.7252C92.572 138.236 93.2585 138.923 93.2585 139.77V146.67C93.2585 147.516 92.572 148.203 91.7252 148.203H84.8252C83.9784 148.203 83.2919 147.516 83.2919 146.67V139.77Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.0919 139.77C97.0919 138.923 97.7784 138.236 98.6253 138.236H105.525C106.372 138.236 107.059 138.923 107.059 139.77V146.67C107.059 147.516 106.372 148.203 105.525 148.203H98.6253C97.7784 148.203 97.0919 147.516 97.0919 146.67V139.77Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.6919 48.1528C55.6919 46.6709 56.8933 45.4695 58.3752 45.4695H104.375C105.857 45.4695 107.059 46.6709 107.059 48.1528C107.059 49.6348 105.857 50.8361 104.375 50.8361H58.3752C56.8933 50.8361 55.6919 49.6348 55.6919 48.1528Z",
					fill: "#ACB5B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9011 58.5027C55.9011 56.809 57.2741 55.436 58.9678 55.436H104.201C105.895 55.436 107.268 56.809 107.268 58.5027V71.1527C107.268 72.8464 105.895 74.2194 104.201 74.2194H58.9678C57.2741 74.2194 55.9011 72.8464 55.9011 71.1527V58.5027Z",
					fill: "#F4F5F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.9675 55.8198H104.201C105.683 55.8198 106.884 57.0206 106.885 58.5024V71.1528C106.884 72.6347 105.683 73.8364 104.201 73.8364H58.9675C57.4857 73.8363 56.285 72.6347 56.2849 71.1528V58.5024C56.2851 57.0207 57.4858 55.82 58.9675 55.8198Z",
					stroke: "#ACB5B9",
					strokeOpacity: .32,
					strokeWidth: .766667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9011 78.8196C55.9011 77.1259 57.2741 75.7529 58.9678 75.7529H104.201C105.895 75.7529 107.268 77.1259 107.268 78.8196V91.4696C107.268 93.1633 105.895 94.5363 104.201 94.5363H58.9678C57.2741 94.5363 55.9011 93.1633 55.9011 91.4696V78.8196Z",
					fill: "#F4F5F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.9675 76.1367H104.201C105.683 76.1367 106.884 77.3375 106.885 78.8193V91.4697C106.884 92.9516 105.683 94.1533 104.201 94.1533H58.9675C57.4857 94.1532 56.285 92.9515 56.2849 91.4697V78.8193C56.2851 77.3376 57.4858 76.1369 58.9675 76.1367Z",
					stroke: "#ACB5B9",
					strokeOpacity: .32,
					strokeWidth: .766667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9011 99.1362C55.9011 97.4426 57.2741 96.0696 58.9678 96.0696H104.201C105.895 96.0696 107.268 97.4426 107.268 99.1362V111.786C107.268 113.48 105.895 114.853 104.201 114.853H58.9678C57.2741 114.853 55.9011 113.48 55.9011 111.786V99.1362Z",
					fill: "#F4F5F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.9675 96.4534H104.201C105.683 96.4534 106.884 97.6541 106.885 99.136V111.786C106.884 113.268 105.683 114.47 104.201 114.47H58.9675C57.4857 114.47 56.285 113.268 56.2849 111.786V99.136C56.2851 97.6542 57.4858 96.4535 58.9675 96.4534Z",
					stroke: "#ACB5B9",
					strokeOpacity: .32,
					strokeWidth: .766667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9011 119.453C55.9011 117.759 57.2741 116.386 58.9678 116.386H104.201C105.895 116.386 107.268 117.759 107.268 119.453V132.103C107.268 133.796 105.895 135.169 104.201 135.169H58.9678C57.2741 135.169 55.9011 133.796 55.9011 132.103V119.453Z",
					fill: "#F4F5F6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.9675 116.77H104.201C105.683 116.77 106.884 117.971 106.885 119.452V132.103C106.884 133.585 105.683 134.786 104.201 134.786H58.9675C57.4857 134.786 56.285 133.585 56.2849 132.103V119.452C56.2851 117.971 57.4858 116.77 58.9675 116.77Z",
					stroke: "#ACB5B9",
					strokeOpacity: .32,
					strokeWidth: .766667
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_dddd_6380_7332)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 115.026,
					cy: 98.9767,
					r: 30.2009,
					fill: "white",
					stroke: "#EEF0F1",
					strokeWidth: 3.06667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M134.297 119.988C134.891 119.385 135.863 119.377 136.466 119.971L164.79 147.865C165.394 148.459 165.401 149.431 164.807 150.034L164.412 150.434C164.369 150.478 164.323 150.517 164.277 150.554L163.2 151.649C162.605 152.252 161.634 152.26 161.031 151.666L135.465 126.488C134.862 125.894 134.854 124.923 135.449 124.32L135.577 124.188L133.92 122.556C133.317 121.962 133.309 120.992 133.904 120.388L134.297 119.988Z",
					fill: "#EEF0F1"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 115.895,
					cy: 96.2739,
					r: 30.3407,
					fill: "white",
					stroke: "#5E696E",
					strokeWidth: 3.06667
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M112.428 102.782L112.386 101.572C112.115 98.2977 113.262 96.4206 116.141 94.7311C118.831 93.1252 119.645 92.1032 119.645 90.1426V90.1009C119.645 88.1403 118.06 86.7012 115.682 86.7012C113.283 86.7012 111.698 88.2237 111.594 90.5806H111.552L105.921 90.6014V90.5597C106.025 85.4498 109.654 81.8623 116.057 81.8623C122.022 81.8623 125.964 85.1786 125.964 89.9132V89.9549C125.964 93.0834 124.442 95.2734 121.501 97.0046C118.727 98.6106 117.955 99.6326 117.955 101.677V102.782H112.428ZM115.411 112.835C113.075 112.835 111.615 111.5 111.615 109.352C111.615 107.183 113.075 105.848 115.411 105.848C117.747 105.848 119.186 107.183 119.186 109.352C119.186 111.5 117.747 112.835 115.411 112.835Z",
					fill: "#FF5100"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.61 119.221C137.204 118.618 138.175 118.61 138.778 119.204L167.252 147.245C167.855 147.839 167.862 148.81 167.268 149.413L166.861 149.826C166.819 149.869 166.775 149.907 166.729 149.944L165.465 151.229C164.871 151.832 163.9 151.839 163.297 151.245L137.596 125.934C136.992 125.34 136.985 124.369 137.579 123.766L137.89 123.448L136.22 121.803C135.616 121.209 135.609 120.237 136.203 119.634L136.61 119.221Z",
					fill: "#5E696E"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dddd_6380_7332",
			x: 29.6252,
			y: 36.2696,
			width: 89.7,
			height: 154.1,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -.766667,
					dy: 1.53333
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.91667 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -2.3,
					dy: 6.13333
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.45 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0.09 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_6380_7332",
					result: "effect2_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -4.6,
					dy: 13.8
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.6 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_dropShadow_6380_7332",
					result: "effect3_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -8.43333,
					dy: 25.3
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5.36667 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0.01 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect3_dropShadow_6380_7332",
					result: "effect4_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect4_dropShadow_6380_7332",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_dddd_6380_7332",
			x: 72.5585,
			y: 62.8666,
			width: 98.217,
			height: 112.24,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: .766667 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.15 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -.766667,
					dy: 3.83333
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.91667 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.09 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_6380_7332",
					result: "effect2_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -2.3,
					dy: 9.2
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.68333 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect2_dropShadow_6380_7332",
					result: "effect3_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: -3.83333,
					dy: 16.1
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.45 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.01 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect3_dropShadow_6380_7332",
					result: "effect4_dropShadow_6380_7332"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect4_dropShadow_6380_7332",
					result: "shape"
				})
			]
		})] })
	]
});
export default SvgNoSearchResultsMobile;
